import { Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { TestConstant } from 'src/app/constants/label-constants';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { CommonConstant, NoRecordFound } from 'src/app/constants/common-constant';
import { CommonService } from 'src/app/services/common/common.service';
import * as saveAs from 'file-saver';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}

@Component({
  selector: 'app-pending-student',
  templateUrl: './pending-student.component.html',
  styleUrls: ['./pending-student.component.scss']
})

export class PendingStudentComponent {
  constructor(
    private CommonService: CommonService,
    private apiUrl: ApiUrlHelper,
    private spinner: NgxSpinnerService,
    private toster: ToastrService,
    public modalService: NgbActiveModal,
  ) { }

  StudentList: any = [];
  TestConstant: any = [];
  testId: number = 0;
  testName: string = ''
  pageSize = 5;
  currentPage = 0;
  enterSearch: string = '';
  searchClose: boolean = false;
  showData: boolean = false;
  SortColumn: any = '';
  sortDirection: any = '';
  pageSizeOptions: number[] = [5, 10, 25, 100];
  totalRows = 0;
  flag: boolean = false;
  exportButton: boolean = true;
  dataSource: MatTableDataSource<any> = new MatTableDataSource();

  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  displayedColumns: string[] = ['rowNumber', 'Student Name', 'Collage Name', 'Email Address', 'Phone Number'];
  CommonConstant: any = [];
  NoRecordFound: any = [];

  ngOnInit(): void {
    this.spinner.show();
    this.getPendingStudentList(this.testId);
    this.CommonConstant = CommonConstant;
    this.TestConstant = TestConstant;
    this.NoRecordFound = NoRecordFound;
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  getPendingStudentList(testId: number) {
    this.showData = false;
    var objModel = {
      examId: testId,
      pageNumber: this.currentPage + 1,
      pageSize: this.pageSize,
      sortColumn: this.SortColumn,
      sortOrder: this.sortDirection,
      strSearch: this.enterSearch
    };
    const apiUrl = this.apiUrl.apiUrl.test.GetTestPendingStudentById;
    this.CommonService.doPost(apiUrl, objModel).pipe().subscribe({
      next: (data) => {
        if (data.success) {
          this.showData = false;
          let TotalRecords = 0;
          this.dataSource.data = data.data;
          this.StudentList = data.data;
          if (this.StudentList.length > 0) {
            TotalRecords = this.StudentList[0].totalRecords;
            this.totalRows = TotalRecords;
            this.showData = false;
            this.exportButton = true;
          }
          else {
            this.showData = true;
            this.exportButton = false;
          }
          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = TotalRecords;
          });
          this.spinner.hide();
          this.flag = true;
        }
        else {
          this.toster.error(data.message)
          this.showData = true;
          this.exportButton = false;
        }
        this.spinner.hide();
      },
      error: (err) => {
        this.spinner.hide();
        this.toster.error(err);
        this.exportButton = false;
        console.log('getGetRoleById-Error', err);
      }
    });
  }

  pageChanged(event: { pageSize: number; pageIndex: number; }) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getPendingStudentList(this.testId);
  }

  SortChange(event) {
    this.sortDirection = event.direction ? event.direction : 'asc';
    this.SortColumn = event.active;
    this.getPendingStudentList(this.testId);
  }

  search(event) {
    if (event.target.value == '') {
      this.enterSearch = '';
      this.currentPage = 0;
      this.getPendingStudentList(this.testId);
      this.searchClose = false;
    }
    else {
      this.searchClose = true;
    }
    if (event.key === "Enter" && event.target.value != '') {
      this.currentPage = 0;
      this.enterSearch = event.target.value;
      this.getPendingStudentList(this.testId);
      this.searchClose = true;
    }
  }

  ExportPendingStudent() {
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.test.ExportPendingStudentById.replace('{examId}', this.testId.toString());
    this.CommonService.GetDownloadCSVFile(apiUrl).pipe().subscribe(
      (buffer) => {
        if (buffer != null) {
          if (buffer.size != 0) {
            const data: Blob = new Blob([buffer], {
              type: "text/csv;charset=utf-8"
            });
            saveAs(data, this.testName + ' Pending-Student-List.xlsx');
            this.spinner.hide();
          } else {
            this.spinner.hide();
            this.toster.error(CommonConstant.FileNotFound);
          }
        } else {
          this.spinner.hide();
          this.toster.error(CommonConstant.NoRecordFound)
        }
      },
      error => {
        this.spinner.hide();
        this.CommonService.checkAuthorize(error);
      });
  }

  RefreshGrid() {
    this.currentPage = 0;
    this.enterSearch = '';
    this.searchClose = false;
    this.sortDirection = '';
    this.SortColumn = '';
    this.getPendingStudentList(this.testId);
  }

  cancelSearch(): void {
    this.currentPage = 0;
    this.enterSearch = '';
    this.getPendingStudentList(this.testId);
    this.searchClose = false;
  }
}